module.exports = require('./helpers/bundle-url').getBundleURL('bLxZJ') + "pokemon-breeding-compatibility-checker.0b46d72c.png" + "?" + Date.now();